/**
 * Headroom.js
 */
 
const componentStickyMenu = () => {

  const header = document.querySelector('.js-site-header');
  if (header) {
    const headroom = new Headroom(header, {
      offset : 400,
      tolerance : 0,
    });
    headroom.init();
  }

};
componentStickyMenu();
